import _asyncToGenerator from "/home/ubuntu/rina_code/without-antd/tilia-earth/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _classCallCheck from "/home/ubuntu/rina_code/without-antd/tilia-earth/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/home/ubuntu/rina_code/without-antd/tilia-earth/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _regeneratorRuntime from "/home/ubuntu/rina_code/without-antd/tilia-earth/node_modules/@babel/runtime/regenerator/index.js";
import { ModalCtrl as t, ThemeCtrl as o, ConfigCtrl as i, OptionsCtrl as n } from "@walletconnect/modal-core";

var d = /*#__PURE__*/function () {
  function d(e) {
    _classCallCheck(this, d);

    this.openModal = t.open, this.closeModal = t.close, this.subscribeModal = t.subscribe, this.setTheme = o.setThemeConfig, o.setThemeConfig(e), i.setConfig(e), this.initUi();
  }

  _createClass(d, [{
    key: "initUi",
    value: function () {
      var _initUi = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var e;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!(typeof window < "u")) {
                  _context.next = 5;
                  break;
                }

                _context.next = 3;
                return import("@walletconnect/modal-ui");

              case 3:
                e = document.createElement("wcm-modal");
                document.body.insertAdjacentElement("beforeend", e), n.setIsUiLoaded(!0);

              case 5:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      function initUi() {
        return _initUi.apply(this, arguments);
      }

      return initUi;
    }()
  }]);

  return d;
}();

export { d as WalletConnectModal };